import { VIDEO_STATES } from '@wix/wix-vod-constants/common';
export const isVideoOverQuota = (videoItem) => videoItem && videoItem.state === VIDEO_STATES.OVER_QUOTA; // TODO remove if
//# sourceMappingURL=quota.js.map